import { gql, TypedDocumentNode } from "@apollo/client";
import { ServerError } from "@flaminem/utils";

import {
  DeleteAttachmentMutation,
  DeleteAttachmentMutationVariables,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { usePerformMutation } from "src/graphql/utils";

export const deleteAttachment = gql(/* GraphQL */ `
  mutation DeleteAttachment($id: ID!) {
    deleteAttachment(id: $id)
  }
`) as TypedDocumentNode<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>;

export const useDeleteAttachment = ({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void;
  onError?: (error: ServerError) => void;
}) => usePerformMutation(deleteAttachment, { onSuccess, onError });
